declare global {
    interface Window {
        dataLayer?: Record<string, unknown>[];
    }
}

export type RegisterType = "provider" | "client";

export function trackRegisterStepComplete(payload: {
    registerType: RegisterType;
    stepKey: string;
    stepIndex: number;
    stepLabel: string;
}) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "register_step_complete",
        register_type: payload.registerType,
        register_step_key: payload.stepKey,
        register_step_index: payload.stepIndex,
        register_step_label: payload.stepLabel,
    });
}
